import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApi = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	width: "512px",
	height: "512px",
	className: "",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
		id: "API",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M57,2H7A5.006,5.006,0,0,0,2,7V57a5.006,5.006,0,0,0,5,5H57a5.006,5.006,0,0,0,5-5V7A5.006,5.006,0,0,0,57,2ZM7,4H57a3,3,0,0,1,3,3v5H4V7A3,3,0,0,1,7,4ZM4,57V14H60V33.649a2.98,2.98,0,0,0-1.506.792l-2.028,2.021A15.478,15.478,0,0,0,55,35.856V33a3,3,0,0,0-3-3H48a3,3,0,0,0-3,3v2.856a15.183,15.183,0,0,0-1.469.611l-2.024-2.025a3.065,3.065,0,0,0-4.234,0l-2.83,2.829a2.992,2.992,0,0,0,0,4.235l2.025,2.025A14.924,14.924,0,0,0,35.856,45H33a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h2.856a14.924,14.924,0,0,0,.612,1.468l-2.025,2.025A2.982,2.982,0,0,0,33.649,60H7A3,3,0,0,1,4,57Zm53,3H35.785a1.1,1.1,0,0,1,.072-.093l2.54-2.54a1,1,0,0,0,.17-1.187,13.047,13.047,0,0,1-1.03-2.469A1,1,0,0,0,36.58,53H33a1,1,0,0,1-1-1V48a1,1,0,0,1,1-1h3.58a1,1,0,0,0,.957-.711,13.047,13.047,0,0,1,1.03-2.469,1,1,0,0,0-.17-1.187l-2.54-2.541a.991.991,0,0,1,0-1.405l2.83-2.83a1.016,1.016,0,0,1,1.406,0l2.54,2.54a1,1,0,0,0,1.187.17,12.842,12.842,0,0,1,2.468-1.029A1,1,0,0,0,47,36.58V33a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v3.58a1,1,0,0,0,.712.958,13.376,13.376,0,0,1,2.475,1.024,1,1,0,0,0,1.179-.173l2.541-2.532A.923.923,0,0,1,60,35.785V57A3,3,0,0,1,57,60Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9,11A3,3,0,1,0,6,8,3,3,0,0,0,9,11ZM9,7A1,1,0,1,1,8,8,1,1,0,0,1,9,7Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16,11a3,3,0,1,0-3-3A3,3,0,0,0,16,11Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,16,7Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23,11a3,3,0,1,0-3-3A3,3,0,0,0,23,11Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,23,7Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50,42a8,8,0,1,0,8,8A8.009,8.009,0,0,0,50,42Zm0,14a6,6,0,1,1,6-6A6.006,6.006,0,0,1,50,56Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9,32a1,1,0,0,0,1-1V26h4v5a1,1,0,0,0,2,0V22a4,4,0,0,0-8,0v9A1,1,0,0,0,9,32Zm3-12a2,2,0,0,1,2,2v2H10V22A2,2,0,0,1,12,20Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19,32a1,1,0,0,0,1-1V26h3a3,3,0,0,0,3-3V21a3,3,0,0,0-3-3H19a1,1,0,0,0-1,1V31A1,1,0,0,0,19,32Zm1-12h3a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H20Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29,32a1,1,0,0,0,1-1V19a1,1,0,0,0-2,0V31A1,1,0,0,0,29,32Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9,38H29a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29,42H9a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z",
				className: "active-path",
				fill: "#0091AE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26,48H9a1,1,0,0,0,0,2H26a1,1,0,0,0,0-2Z",
				className: "active-path",
				fill: "#0091AE"
			})
		]
	}) })
});
export default SvgApi;
